import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { GlobalService } from "src/app/services/global.service";
import { MoodleWebService } from "src/app/services/moodle-web.service";
import { AsyncEmailValidator } from "./async-email-validator";
import { CheckboxValidator } from "./checkbox-validator";
import { PasswordValidator } from "./password-validator";
import { Quiz, Answer, UserQuizAttemptResponse } from "./moodle";
import { inject } from "@angular/core";
import { LoadingService } from "src/app/services/loading.service";

export class MoodleQuiz {    
  public attemptsId: Array<{id: number, uniqueid: number}> = [];
  public quizData: Array<Quiz> | null = null;
  private currentAttempt: number = 0;
  public quizForm: FormGroup;

  public fb: FormBuilder = inject(FormBuilder);
  public globalService: GlobalService = inject(GlobalService);
  public moodleWebService: MoodleWebService = inject(MoodleWebService);
  public loadingService: LoadingService = inject(LoadingService);
  readonly emailValidator: AsyncEmailValidator = inject(AsyncEmailValidator);
  readonly checkboxValidator: CheckboxValidator = inject(CheckboxValidator);
  readonly passwordValidator: PasswordValidator = inject(PasswordValidator);

  constructor() {}

  get quizzesFormArray() {
    return this.quizForm.get('quizzes') as FormArray;
  }

  createQuizForm(data: Array<Quiz>) {
    this.quizForm = this.fb.group({
      quizzes: this.fb.array([])
    });
    for (const quiz of data) {  
      if (quiz.questions.length > 0) {
        let quizArray: FormArray = this.fb.array([]);
        for (const question of quiz.questions) {
          let questionsGroup: FormGroup = this.fb.group({});
          if (question.type === "multichoice") {
            if (question.single === 0) {
              questionsGroup.setValidators(this.checkboxValidator.atLeastOneChecked())
              for (const answer of question.answers) {            
                questionsGroup.addControl(answer.id.toString(), this.fb.control(null));
              }   
              quizArray.push(questionsGroup);            
            }
            else if(question.single === 1){
              questionsGroup.addControl(question.id.toString(), this.fb.control(null, Validators.required));
              quizArray.push(questionsGroup);  
            }            
          }
          else if(question.type === 'essay') {
            questionsGroup.addControl(question.id.toString(), this.fb.control(null, Validators.required));
            quizArray.push(questionsGroup);            
          }
          
        }        
        this.quizzesFormArray.push(quizArray);
      }    
    }      
  }

  async createQuiz(quizzes: Array<Quiz>) {
    this.quizData = [];
    if (quizzes) {
      this.quizData = quizzes;    
      this.createQuizForm(this.quizData);    
      for (let quizIdx = 0; quizIdx < quizzes.length; quizIdx++) {
        await this.moodleWebService.getUserAttempts(quizzes[quizIdx].quizzId, this.moodleWebService.auth.currentUser().auth.id, 'unfinished').then((quiz: UserQuizAttemptResponse) => {     
          let ids: {id: number, uniqueid: number};     
          if (quiz.attempts.length > 0 && quiz.attempts[0].state === "inprogress") {
            ids = {
              id: quiz.attempts[0].id!,
              uniqueid: quiz.attempts[0].uniqueid!
            }  
            this.attemptsId.push(ids);
          }
          else{
            this.moodleWebService.startQuizAttempt(quizzes[quizIdx].quizzId).then((data)=>{
              if (data.attempt && typeof(data.attempt.id) === "number" && typeof(data.attempt.uniqueid) === "number") {
                ids = {
                  id: data.attempt.id,
                  uniqueid: data.attempt.uniqueid
                }    
                this.attemptsId.push(ids);
              }
            });
          }
        });
      }
    }
  }

  async processQuiz(quizIdx: number, questionIdx: number) {    
    if (this.quizData !== null) {                              
      let attemptQuery: string = "";
      let answerIndex: number = 0;
      // this.moodleWebService.getAttemptData(this.attemptsId[quizIdx].id, questionIdx)
      for (const [key, value] of Object.entries(this.quizzesFormArray.value[quizIdx][questionIdx])) {
        let answerValue: number | string = "";
        switch(typeof(value)){
          case 'string':
            answerValue = value;
            break;
          case 'boolean':
            answerValue = value ? 1 : 0;
            break;
          case 'number':
            this.quizData[quizIdx].questions[questionIdx].answers.forEach((answer: Answer, answerIdx: number) => {
              if (answer.id === value) answerValue = answerIdx;                  
            });
        }
        const questionType: string = this.quizData[quizIdx].questions[questionIdx].type;
        const isSingle: number = this.quizData[quizIdx].questions[questionIdx].single;
        attemptQuery += this.moodleWebService.setQuizAttemptData(answerIndex, this.moodleWebService.getQuestionName(questionType, isSingle, this.attemptsId[quizIdx].uniqueid, questionIdx + 1, answerIndex), answerValue);    
        attemptQuery += this.moodleWebService.setQuizAttemptData(answerIndex + 1, this.moodleWebService.getQuestionIndex(this.attemptsId[quizIdx].uniqueid, questionIdx + 1 ) + '_:flagged', 0);    
        attemptQuery += this.moodleWebService.setQuizAttemptData(answerIndex + 2, this.moodleWebService.getQuestionIndex(this.attemptsId[quizIdx].uniqueid, questionIdx + 1 ) + '_answerformat', 1);                                
        attemptQuery += this.moodleWebService.setQuizAttemptData(answerIndex + 3, this.moodleWebService.getQuestionIndex(this.attemptsId[quizIdx].uniqueid, questionIdx + 1 ) + '_:sequencecheck', 1);                                     
        answerIndex++;
      }  

      await this.moodleWebService.processQuizAttempt(this.attemptsId[quizIdx].id, attemptQuery, 0);                       
    }
  }

  async submitQuiz() {
    this.loadingService.setLoading(true);
    for (let idx = 0; idx < this.attemptsId.length; idx++) {
      await this.moodleWebService.processQuizAttempt(this.attemptsId[idx].id, "", 1);
    }
    this.loadingService.setLoading(false);
    console.log("Form valid: ", this.quizForm.valid);
    console.log("Form values: ", this.quizForm.value)
  }
}
